import React from 'react'
import ButtonGroup from 'constructicon/button-group'
import ButtonShare from 'constructicon/button-share'
import Content from '../../ui/Content'
import Section from '../../ui/Section'

const SocialShare = ({
  alignment,
  apiParams,
  backgroundImage,
  background,
  copy,
  copyAlignment,
  foreground,
  items = [],
  layout,
  meta,
  size,
  spacing,
  subtitle,
  title,
  titleForeground
}) => (
  <Section
    alignment={alignment}
    backgroundImage={backgroundImage}
    background={background}
    foreground={foreground}
    size={size}
    spacing={spacing}>
    <Content
      copy={copy}
      copyAlignment={copyAlignment}
      layout={layout}
      subtitle={subtitle}
      title={title}
      titleForeground={titleForeground}>
      <ButtonGroup>
        {items
          .filter(item => item.network)
          .map((item, index) => (
            <ButtonShare
              key={index}
              type={item.network === 'email' ? 'mail' : item.network}
              share
              caption={meta.ogDescription}
              title={meta.ogTitle}
              url={meta.ogUrl && meta.ogUrl.url ? meta.ogUrl.url : undefined}
            />
          ))}
      </ButtonGroup>
    </Content>
  </Section>
)

export default SocialShare



// WEBPACK FOOTER //
// ./components/slices/SocialShare/index.js